import { isBefore, isEqual, isValid } from 'date-fns';
import { DATE_FORMATS, INPUT_MASK, RANGE_SEPARATOR } from './DateRange.constants';
import { DateType, ParsedDateRange } from './DateRange.types';
import { parseDate } from './dateRangeUtils';

const isDateValid = (date: DateType): boolean => date === null || isValid(date);

const parseRawDate = (date: string): DateType =>
  date !== INPUT_MASK ? parseDate(date, DATE_FORMATS.MONTH_DAY_YEAR) : null;

export const parseDateRangeString = (dateString: string): ParsedDateRange => {
  const [rawStart, rawEnd] = dateString.split(RANGE_SEPARATOR);
  const parsedStartDate = parseRawDate(rawStart);
  const parsedEndDate = parseRawDate(rawEnd);
  const isStartDateValid = isDateValid(parsedStartDate);
  const isEndDateValid = isDateValid(parsedEndDate);
  let isRangeValid = isStartDateValid && isEndDateValid;
  if (parsedStartDate && parsedEndDate && isRangeValid) {
    isRangeValid = isBefore(parsedStartDate, parsedEndDate) || isEqual(parsedStartDate, parsedEndDate);
  }

  return {
    rawStart,
    rawEnd,
    parsedStartDate,
    parsedEndDate,
    isStartDateValid,
    isEndDateValid,
    isRangeValid,
  };
};
